<template>
    <card title="Patient Cases">
        <template #header-right>
            <div class="d-flex" style="gap: 8px;">
                <b-button v-if="$permissions.some(p => p.permissionCodeName === 'Admin/Case Question Sets')"
                    variant="secondary" size="sm" v-b-modal.questionSetsModal>
                    <i class="fa fa-gear"></i>
                    Manage Question Sets
                </b-button>
                <b-button
                    v-if="$permissions.some(p => p.permissionCodeName === 'Compliance/Edit Case Category Permissions') && categories.length > 0"
                    variant="secondary" size="sm" @click="showCategoryPermissionsModal = true">
                    <i class="fa fa-lock"></i>
                    Case Permissions
                </b-button>
            </div>
        </template>

        <CasesListComponent ref="casesList"
            :status-filter.sync="currentFilter"
            :show-status="currentFilter === 'completed' || currentFilter === 'all'"
            :initial-case-id="id" />

        <b-modal id="questionSetsModal" hide-footer no-fade title="Question Sets" size="lg">
            <TaskQuestionSets :entity-type="EntityType.Case" :default-scope-options="problems"
                default-scope-name="Case Type" />
        </b-modal>

        <CaseCategoryPermissionsModal :show.sync="showCategoryPermissionsModal" />
    </card>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CasesListComponent from '@/components/Cases/CasesListComponent.vue';
import { EntityType } from '@/models/EntityType';
import TaskQuestionSets from '@/components/Tasks/TaskQuestionSets.vue';
import CaseCategoryPermissionsModal from '@/components/Cases/CaseCategoryPermissionsModal.vue';
import axios from 'axios';
import { CaseCategory } from '@/models/Configuration';

@Component({
    name: "CasesPage",
    components: {
        CasesListComponent,
        TaskQuestionSets,
        CaseCategoryPermissionsModal
    },
})
export default class CasesPage extends Vue {
    @Prop({ type: String, default: 'opened' }) private defaultStatus!: string;
    @Prop({ type: String, default: undefined }) private id?: string;

    private currentFilter: string = 'opened';
    private showCategoryPermissionsModal: boolean = false;
    private categories: CaseCategory[] = [];

    created() {
        this.currentFilter = this.defaultStatus;
        this.getCaseProblems();
        this.getCaseCategories();
        console.log("%c Created CasesPage", "color: green");
    }

    beforeDestroy() {
        console.log('%c Destroying CasesPage', 'color: red');
    }

    @Watch('defaultStatus')
    onDefaultStatusChanged(newValue: string) {
        this.currentFilter = newValue;
    }

    EntityType = EntityType;

    protected problems: string[] = [];

    async getCaseProblems() {
        try {
            const resp = await axios.get<string[]>("/Case/problems");
            this.problems = resp.data;
        } catch (err) {
            console.error(err);
        }
    }

    async getCaseCategories() {
        try {
            const resp = await axios.get<CaseCategory[]>("/Case/categories");
            this.categories = resp.data;
        } catch (err) {
            console.error(err);
        }
    }
}
</script>

<style scoped></style>
